export default {
    props: {
        id:          { type: String },
        name:        { type: String },
        description: { type: String },
        locale:      { type: String },
        duration:    { type: String },
        price:       { type: Object },
        recurring:   { type: Boolean },
        active:      { type: Boolean },
        disabled:    { type: Boolean, default: false },
        draftLine:   { type: Object, default: null },
    },

    methods: {
        activate(packageId) {
            this.$emit('activate', packageId);
        },

        openModal(bundleId) {
            this.$emit('openModal', bundleId);
        },

        openDeactivateModal(bundleId) {
            this.$emit('openDeactivateModal', bundleId);
        },

        resumeDraft() {
            this.$emit('resumeDraft', this.draftLine);
        },

        deleteDraft() {
            this.$emit('deleteDraft', this.draftLine.log_contractlineid);
        },
    },
};
